import {normalize, schema, denormalize} from 'normalizr';

const device = new schema.Entity('devices', {}, {idAttribute: "id"});

export function normalizeDatos(myData) {

    const mySchema = {devices: [device]};
    const normalizedData = normalize(myData, mySchema);
    return normalizedData;
}


export function normalizeDato(myData) {

    const mySchema = device;
    const normalizedData = normalize(myData, mySchema);

    return normalizedData;
}

export function denormalizeDato(myData, store) {

    const mySchema = device;

    const normalizedData = denormalize(myData, mySchema, store);

    return normalizedData;
}

export default device;
